var classes = {"badge":"index-module_badge__LFSGS","themed":"index-module_themed__RzZ7w","inverted":"index-module_inverted__kiFh2"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
